module.exports = __webpack_public_path__ + "img/75749.89d5be4c.svg";